
import { Header, User } from "../../../models";
import CmsHomepageModuleEnum from "../../../enums/cmsHomepageModuleEnum";

export default {
  props: {
    treatment: {
      required: false,
      default: null,
    },
    sites: {
      required: true,
    },
    url: {
      required: true,
    },
    disabled: {
      required: false,
      default: () => {
        return false;
      },
    },
    defaultSize: {
      required: false,
      default: false,
    },
    isBanner: {
      required: false,
      default: false,
    },
    type: [Header, Object],
    default: function () {
      return new Header();
    },
  },
  data: () => ({
    dialog: false,
    isMounted: false,
  }),
  methods: {
    price(siteId) {
      return this.treatment.pricePerSite.find((doc) => doc.siteId == siteId)
        .price;
    },
    redirect(site) {
      this.$emit('closeMenu')
      if (this.chainAppointmentButtonOverrideUrl) {
        if (this.chainAppointmentButtonOverrideUrl != '') {
          window.open(this.chainAppointmentButtonOverrideUrl, '_self')
        }
      } else if (site.appointmentButtonOverrideUrl) {
        if (site.appointmentButtonOverrideUrl != '') {
          window.open(site.appointmentButtonOverrideUrl, '_self')
        }
      } else {
        /**
         * Redirect to FNB if we're on webshop or profile
         */
        if (this.$router.currentRoute.path.includes('nettbutikk') || window.location.host.includes('profil.')) {
          window.open(`${this.url}/booking/${site.siteId}/behandlinger`, '_self')
        } else {
          const cartCount = this.$store.getters['cart/getCartCount']
          const cart = this.$store.getters['cart/getCart']
          /**
           * Redirect to checkout instead of treatmentspage if the user have items in cart
           */
          if (cartCount > 0 && cart.siteId === site.siteId) {
            let routeData = this.$router.resolve({name: 'redirect', path: "/checkout"});
            if (this.user.onlineSluttKundeId != 0) {
              localStorage.setItem('expires', JSON.stringify(new Date(new Date().getTime() + 10*60000)))
              localStorage.setItem('currentStep', JSON.stringify('cart'));
            }
            window.open(routeData.href, '_self');
          } else {
            /**
             * Normal router push to treatmentspage when on homepages
             */
             localStorage.setItem('selectedSalon', site.siteId);
            this.$router.push(`/behandlinger?department=${site.siteId}`)
          }
        }
      }
      this.toggleDialog()
    },
    toggleDialog() {
      this.dialog = !this.dialog;
      this.$emit("closeMenu");
    },
  },
  computed: {
    salons() {
      let sites = [];
      let siteIds = this.sites.map((s) => s.siteId);
      siteIds.forEach((siteId) => {
        if (this.treatment) {
          this.treatment.pricePerSite.forEach((priceSite) => {
            if (priceSite.siteId == siteId)
              sites.push(this.sites.find((s) => s.siteId == siteId));
          });
        } else {
          sites.push(this.sites.find((s) => s.siteId == siteId));
        }
      });
      return sites;
    },
    user() {
      return new User(this.$store.getters["app/get"]("user")) || new User();
    },
    chainAppointmentButtonOverrideText() {
      return this.$store.getters["cmsConfigHomepage/getAppointmentButtonOverrideText"];
    },
    chainAppointmentButtonOverrideUrl() {
      return this.$store.getters["cmsConfigHomepage/getAppointmentButtonOverrideUrl"];
    },
    showPrice() {
      var modules = this.$store.getters["cmsConfigHomepage/getModules"];
      let moduleShowPricesValue = modules.find(
        (m) => m.moduleId == CmsHomepageModuleEnum.PRICES
      )?.visible;
      let prices = true;
      if (moduleShowPricesValue != undefined && moduleShowPricesValue != null)
        prices = moduleShowPricesValue;
      return prices;
    },
    isDraft() {
      return this.$store.getters["cmsConfigHomepage/isDraftMode"];
    },
  },
  mounted() {
    this.isMounted = true;
    this.$root.$on("openSalonDialog", () => {
      this.openDialog();
    });
  },
};
